// src/theme.js
import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    brand: {
      50: "#F0F9FF",
      100: "#E0F2FE",
      200: "#BAE6FD",
      300: "#7DD3FC",
      400: "#34B8E8",
      500: "#0C7FBC",
      600: "#086AA0",
      700: "#064C8B",
      800: "#063F74",
      900: "#032D54",
    },
    accent: {
      50: "#FFF7D6",
      100: "#FFED99",
      200: "#FFE15C",
      300: "#FFD52E",
      400: "#F8B625",
      500: "#F47A22",
      600: "#D73522",
      700: "#A51F18",
      800: "#8B2A94",
      900: "#551B63",
    },
  },
  fonts: {
    heading: '"Shrikhand", "Cooper Black", "Arial Black", "Poppins", sans-serif',
    body: '"Inter", sans-serif',
  },
  fontWeights: {
    normal: 400,
    medium: 500,
    bold: 700,
    extrabold: 800,
  },
  fontSizes: {
    xs: "0.75rem",
    sm: "0.875rem",
    md: "1rem",
    lg: "1.125rem",
    xl: "1.25rem",
    "2xl": "1.5rem",
    "3xl": "1.875rem",
    "4xl": "2.25rem",
    "5xl": "3rem",
    "6xl": "3.75rem",
    "7xl": "4.5rem",
    "8xl": "6rem",
  },
  styles: {
    global: (props) => ({
      body: {
        bg: props.colorMode === 'dark' ? 'gray.900' : 'white',
        color: props.colorMode === 'dark' ? 'white' : 'gray.900',
      },
    }),
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'bold',
        borderRadius: 'full',
      },
      sizes: {
        xl: {
          h: 16,
          minW: 16,
          fontSize: 'xl',
          px: 8,
        },
      },
      variants: {
        solid: (props) => ({
          bg: props.colorMode === 'dark' ? 'brand.400' : 'brand.500',
          color: 'white',
          _hover: {
            bg: props.colorMode === 'dark' ? 'brand.500' : 'brand.600',
          },
        }),
        outline: (props) => ({
          borderColor: props.colorMode === 'dark' ? 'brand.400' : 'brand.500',
          color: props.colorMode === 'dark' ? 'brand.400' : 'brand.500',
          _hover: {
            bg: props.colorMode === 'dark' ? 'brand.800' : 'brand.50',
          },
        }),
      },
    },
    Heading: {
      baseStyle: {
        fontWeight: 'normal',
        letterSpacing: '0',
        lineHeight: '1.02',
      },
    },
  },
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
});

export default theme;
